import InspectedDatabasePage from './InspectedDatabasePage-compose';

export default InspectedDatabasePage;
